/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useRef } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _, { sortBy } from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { DisputeCodesSelected, ManufactureTableHead } from './TableHead';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  tabHighLigther,
  autoFormateDate,
  compareQuarterAndYear,
  convertToFourDigitYear,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  dispatchSelectedCodeOption,
  dispatchQtrRange,
  dispatchErrorMsgDisputeCode,
  dispatchPerformDisputeResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  getSelectedCode,
  dispatchRebatePrograme,
  getManufactureName,
  getManufactureID,
  dispatchStatus,
  getManufacturerList,
  dispatchRebateProgramName,
  getManufactureOption,
  dispatchSelectedDrug,
  getDisputeCodeReport,
  dispatchDisplayObjCodes,
  dispatchCodeName,
  dispatchMfgSelected,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  NOT_SELECTED_ROW,
  ERRORMESSAGE_SELECT_CODE_VALUE,
  FROM_QTR_CANNOT_BE_GREATER_THAN_TO_QTR,
  BEGIN_QUATER_REQ,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const DisputeCodes = (props) => {
  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.DisputeCodeReducer?.performDisputeResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.planType
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.rebateProgram
  );
  const getRebateProgramNameList = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.rebateProgramName
  );
  const resultManufacturerGrid = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.manufacturerList
  );

  const disputeCodeReportList = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.disputeCodeReport
  );
  const resultSelectedCode = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.selectedCode
  );
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.errorMsgDisputeCode
  );
  const fetchDisputeCodeList = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer?.selectedOptionDisputeCode
  );

  const {
    open,
    closed,
    selectedRowIndexValue,
    selectedRowIndexCodeValue,
    selectedValue: selectedDispatchValue,
    drugSelection: drugSelectionValue,
    selectedDisputeCodes: selectedDisputeCodesValue,
    mfgListSelected,
  } = useSelector((state) => state?.sharedState?.DisputeCodeReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const { startQtr: startQtrValue, endQtr: endQtrValue } = useSelector(
    (state) => state?.sharedState?.DisputeCodeReducer
  );
  const [radioList, setRadioList] = useState([]);
  const [manufacturerList, setManufacturerList] = useState([]);
  const [selectedCode, setSelectedCode] = useState([]);
  const gridRef = useRef();

  const [rebateProgramList, setRebateProgramList] = useState([]);

  const dispatch = useDispatch();
  const [selectedValue, setselectedValue] = useState(selectedDispatchValue);
  const [drugSelection, setDrugSelection] = useState(drugSelectionValue);
  const [selectedDisputeCodes, setselectedDisputeCodes] = useState(
    selectedDisputeCodesValue
  );

  const [selectedRowCodeIndex, setSelectedRowCodeIndex] = useState(
    selectedRowIndexCodeValue
  );
  const [selectedRowIndex, setSelectedRowIndex] = useState(
    selectedRowIndexValue
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedErrorRows, setSelectedErrorRows] = useState([]);
  const [selectedCodeValue, setSelectedCodeValue] = useState([]);
  const [startQtr, setStartQtr] = useState(startQtrValue);
  const [endQtr, setEndQtr] = useState(endQtrValue);
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [manufacturerWithId, setManufactureWithId] = useState([]);
  const [gridApi, setGridApi] = React.useState(null);

  const [fullScreenView, setFullScreenView] = useState(false);
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [checkboxValues, setCheckboxValues] = useState({
    open: open,
    closed: closed,
  });
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };
  // local variable

  const [state, setState] = useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',

          Open: true,
          Closed: false,
        }
  );

  // dispatch function
  const setPerformDisputeScrData = (value) =>
    dispatch(dispatchPerformDisputeResolutionObj(value));

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformDisputeScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformDisputeScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformDisputeScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeCode(unique));
  };
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      if (!value || value == -1)
        localErr.push({
          field: 'rebateProgramCd',
          messgae: REBATE_PROGRAM_REQUIRED,
        });
    }

    let fromError = [];
    let toError = [];
    if (type === 'startQtr') {
      const data = autoFormateDate(value?.toUpperCase());
      if (!value || data.trim() === '') {
        fromError = [{ field: 'startQtr', message: BEGIN_QUATER_REQ }];
        setStartQtr('');
      } else {
        localErr = localErr.filter((item) => item.field !== 'startQtr');
        setStartQtr(data);
        fromError = validateQuarter(data, 'startQtr');
        if (!endQtr && !fromError.length) {
          setEndQtr(data);
        }
      }
    }
    if (type === 'endQtr' && value.trim().length > 0) {
      const data = autoFormateDate(value?.toUpperCase());
      toError = [];
      localErr = localErr.filter((item) => item.field !== 'endQtr');

      toError = validateQuarter(data, 'endQtr');
      setEndQtr(data);
    }
    if (endQtr && startQtr && fromError.length === 0 && toError.length === 0) {
      const toQtrYear =
        endQtr.length === 4
          ? convertTo4DigitQtr(endQtr).split('Q')
          : endQtr.split('Q');
      const fromQtrYear =
        startQtr.length === 4
          ? convertTo4DigitQtr(startQtr).split('Q')
          : startQtr.split('Q');
      if (
        compareQuarterAndYear(
          toQtrYear[0],
          toQtrYear[1],
          fromQtrYear[0],
          fromQtrYear[1]
        ) === -1
      ) {
        localErr = localErr.filter((item) => item.field !== 'startQtr>endQtr');
        localErr.push({
          field: 'startQtr>endQtr',
          message: FROM_QTR_CANNOT_BE_GREATER_THAN_TO_QTR,
        });
      }
    }
    localErr = [...localErr, ...fromError, ...toError];

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeCode(unique));
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/disputeCodes', true);
    } else {
      tabHighLigther('/disputeCodes', false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Grid functionality for mfg

  const [numberOfSelectedRows, setNumberOfSelectedRows] = useState(0);
  const onSelectionChanged = (e, isAllClicked) => {
    if (isAllClicked) {
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < manufacturerList.length; i++) {
        temp.push({
          manufacturerID: manufacturerList[i].mfgId,
        });
      }
      selectedMenuName.sort();
      setManufactureWithId(temp);
      setSelectedRows(selectedMenuName);
      dispatch(dispatchMfgSelected([]));
    } else {
      const selectedRows = e.api.getSelectedRows();
      setNumberOfSelectedRows(e.api.getSelectedRows().length);
      const temp = [];
      const selectedMenuName = [];
      const selectedMfgId = selectedRows.map((item) => item.mfgId);
      const selectedIndexes = [];
      manufacturerList.forEach((item, index) => {
        if (selectedMfgId.indexOf(item.mfgId) != -1) {
          selectedIndexes.push(index);
        }
      });
      setSelectedRowIndex(selectedIndexes);
      dispatch(dispatchMfgSelected(selectedRows));
      for (let i = 0; i < selectedRows.length; i++) {
        temp.push({
          manufacturerID: selectedRows[i].mfgId,
        });
      }
      selectedMenuName.sort();
      setManufactureWithId(temp);

      setSelectedRows(selectedRows);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field != 'nomanufacture');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgDisputeCode(unique));
    }
  };

  const getSelectedRowData = () => {
    const selectedData = gridApi.getSelectedRows();
    return selectedData;
  };

  // Grid functionality for selected code
  const [numberOfSelectedCodeRows, setNumberOfSelectedCodeRows] = useState(0);
  const onSelectionCodeChanged = (e, isAllChecked) => {
    if (isAllChecked) {
      const temp1 = [];
      const selectedCodeMenuName = [];
      for (let i = 0; i < selectedCode.length; i++) {
        temp1.push({
          codeValue: selectedCode[i].codeValuetemp,
        });
      }
      selectedCodeMenuName.sort();
      setSelectedCodeValue(temp1);
      setSelectedErrorRows(selectedCodeMenuName);
    } else {
      const selectedCodeRows = e.api.getSelectedRows();
      setNumberOfSelectedCodeRows(e.api.getSelectedRows().length);
      const temp1 = [];
      const selectedCodeMenuName = [];
      const selectedCodeId = selectedRows.map((item) => item.codeValuetemp);
      const selectedIndexes = [];
      selectedCode.forEach((item, index) => {
        if (selectedCodeId.indexOf(item.codeValuetemp) != -1) {
          selectedIndexes.push(index);
        }
      });
      setSelectedRowCodeIndex(selectedIndexes);
      for (let i = 0; i < selectedCodeRows.length; i++) {
        temp1.push({
          codeValue: selectedCodeRows[i].codeValuetemp,
        });
      }
      selectedCodeMenuName.sort();

      setSelectedCodeValue(temp1);
      setSelectedErrorRows(selectedCodeRows);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field != 'noCodeSelected');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgDisputeCode(unique));
    }
  };

  const getSelectedCodeRowData = () => {
    const selectedCodeData = gridApi?.getSelectedCodeRows();
    return selectedCodeData;
  };

  // Search button on click functionality
  const onClickOnSearch = async () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg || [];
    const sRows =
      (selectedValue == '-1' ? manufacturerList : selectedRows) || [];
    if (sRows.length == 0) {
      localErr.push({
        field: 'nomanufacture',
        errorType: 'manufactureRequired',
        message: NOT_SELECTED_ROW,
      });
    }
    let cRows =
      (selectedDisputeCodes == 'All' ? selectedCode : selectedErrorRows) || [];
    if (cRows.length == 0) {
      localErr.push({
        field: 'noCodeSelected',
        errorType: 'selectedCodeRequired',
        message: ERRORMESSAGE_SELECT_CODE_VALUE,
      });
    }

    if (
      state.rebateProgramCd === '-1' ||
      state.rebateProgramCd === 'undefined'
    ) {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const fromError = validateQuarter(startQtr, 'fromQtr');
    let toError = [];
    if (endQtr.trim().length > 0) {
      toError = validateQuarter(endQtr, 'toQtr');
    }

    if (
      endQtr.length &&
      startQtr.length &&
      fromError.length === 0 &&
      toError.length === 0
    ) {
      const toQtrYear =
        endQtr.trim().length > 0 ? endQtr.split('Q') : startQtr.split('Q');
      const fromQtrYear = startQtr.split('Q');
      if (
        compareQuarterAndYear(
          toQtrYear[0],
          toQtrYear[1],
          fromQtrYear[0],
          fromQtrYear[1]
        ) === -1
      ) {
        localErr.push({
          field: 'startQtr>endQtr',
          message: FROM_QTR_CANNOT_BE_GREATER_THAN_TO_QTR,
        });
      }
    }
    if (localErr?.length > 0) {
      handleScrollToEvent();
    }
    localErr = [...localErr, ...fromError, ...toError];
    const unique = [...new Set(localErr)];

    dispatch(dispatchErrorMsgDisputeCode(unique));

    if (
      state.rebateProgramCd != '-1' &&
      sRows.length > 0 &&
      cRows.length > 0 &&
      startQtr != ''
    ) {
      const today = new Date();
      const quarter = Math.floor(today.getMonth() / 3) + 1;
      const year = today.getFullYear();
      const quarterString = quarter.toString();
      const yearString = year.toString();
      const formattedQuarter = quarterString.padStart(2);

      const currentQuarterWithYear = `${formattedQuarter}Q${yearString}`.trim();
      const mID = manufacturerWithId.map((obj) => obj.manufacturerID);
      const code = cRows?.map((obj) => obj.codeValuetemp);

      const drugSelectionBasis = {
        Dispute: {
          disputeType1Cd: ['D'],
          disputeType2Cd: ['$'],
        },
        Adjustment: { disputeType1Cd: ['A'], disputeType2Cd: ['$'] },
        Both: {
          disputeType1Cd: ['A'],
          disputeType2Cd: ['D'],
        },
      };

      setSearchClicked(true);
      const response = await dispatch(
        getDisputeCodeReport({
          programCd: rebateProgramName?.rebateProgramCd,
          mfgId:
            selectedValue == '-1'
              ? ['-1']
              : mID?.length ==
                resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO?.length
              ? ['-1']
              : mID,
          mfgType: sRows[0]?.mfgTypeCd,
          beginQtr: startQtr,
          endQtr: endQtr || currentQuarterWithYear,
          adjustDisputeCd: code,
          disputeType1Cd: drugSelectionBasis[drugSelection].disputeType1Cd,
          disputeType2Cd: drugSelectionBasis[drugSelection].disputeType2Cd,
          openStatus: checkboxValues.open ? 1 : 0,
          closeStatus: checkboxValues.closed ? 1 : 0,
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(
        dispatchQtrRange({
          startQtr,
          endQtr,
          selectedCodeValue,
          selectedRowIndexValue: selectedRowIndex,
          selectedRowIndexCodeValue: selectedRowCodeIndex,
          selectedDisputeCodes,
        })
      );
      dispatch(getManufactureName(sRows));
      dispatch(getManufactureID(manufacturerWithId));
      cRows = sortBy(cRows, 'codeValuetemp');
      if (response?.disputeCodeReportVO?.length) {
        const data = Object.groupBy(
          response.disputeCodeReportVO,
          ({ disputeCode }) => disputeCode
        );
        const availCodes = Object.keys(data);
        cRows = cRows.filter(
          (obj) => availCodes.indexOf(obj.codeValuetemp) !== -1
        );
      }
      // dispatch(dispatchCodeName(cRows));
      dispatch(dispatchSelectedCodeOption(cRows));
      dispatch(getManufactureOption(selectedValue));
      dispatch(dispatchSelectedDrug(drugSelection));
      dispatch(
        dispatchStatus({
          open: checkboxValues.open,
          closed: checkboxValues.closed,
        })
      );
      dispatch(
        dispatchDisplayObjCodes({
          rebateProgramName,
          startQtr,
          endQtr,
          selectedCodeValue,
          selectedRowIndexValue: selectedRowIndex,
          selectedRowIndexCodeValue: selectedRowCodeIndex,
          selectedDisputeCodes,
          allManufacturer: sRows,
          manufacturerWithId,
          selectedOptionDisputeCode: cRows,
          selectedValue,
          drugSelection,
          open: checkboxValues.open,
          closed: checkboxValues.closed,
          manufacturerList: resultManufacturerGrid,
        })
      );
      if (response?.disputeCodeReportVO.length) {
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));
        updateTabs.push({
          navTo: '/displayDisputeCodes',
          value: 'Display Dispute Code Summary',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
        props.history.push({
          pathname: '/displayDisputeCodes',
        });
        dispatch(clearReduxForFilterAndSort('/displayDisputeCodes'));
      }
    }
  };

  if (
    isSearchClicked &&
    disputeCodeReportList?.disputeCodeReportVO?.length > 0
  ) {
    // setSearchClicked(false);
    // const updateTabs =
    //   JSON.parse(localStorage.getItem('tabItemsData')) === null
    //     ? []
    //     : JSON.parse(localStorage.getItem('tabItemsData'));
    // updateTabs.push({
    //   navTo: '/displayDisputeCodes',
    //   value: 'Display Dispute Code Summary',
    // });
    // localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    // props.history.push({
    //   pathname: '/displayDisputeCodes',
    // });
    // dispatch(clearReduxForFilterAndSort('/displayDisputeCodes'));
  }
  // Manufacturer Grid From API
  useEffect(() => {
    setManufacturerList(resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO);
  }, [resultManufacturerGrid]);
  useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);
  // Selected Code from API

  useEffect(() => {
    let data =
      resultSelectedCode?.ADJUSTMENT_DISPUTE_CD?.map((item) => {
        return {
          ...item,
          codeValuetemp: item.codeValueID.codeValue,
        };
      }) || [];

    data = sortBy(data, 'codeValuetemp');

    setSelectedCode(data);
  }, [resultSelectedCode]);
  useEffect(() => {
    dispatch(
      getSelectedCode({
        codeDomainList: ['ADJUSTMENT_DISPUTE_CD'],
      })
    );
  }, []);
                
  // remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgDisputeCode([]));
  }, [ state.planTypeCd, planTypeList, selectedValue, selectedDisputeCodes, fullScreenView, state.rebateProgramCd, startQtr, endQtr, drugSelection, checkboxValues.open, checkboxValues.closed]);
  
  // setting Quarter From
  const handlefromChange = (event) => {
    let { value } = event.target;
    if (value?.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setStartQtr(value);
    let localErr = getErrorMsg || [];
    localErr =
      localErr && localErr?.filter((item) => item.field !== 'startQtr');

    const unique = [...new Set(localErr)];

    dispatch(dispatchErrorMsgDisputeCode(unique));
  };
  // setting Quarter To
  const handleToChange = (event) => {
    let { value } = event.target;
    if (value.includes('q')) {
      value = value?.replace('q', 'Q');
    }
    setEndQtr(value);
    let localErr = getErrorMsg || [];
    localErr =
      localErr && localErr?.filter((item) => item.field !== 'startQtr>endQtr');

    const unique = [...new Set(localErr)];

    dispatch(dispatchErrorMsgDisputeCode(unique));
  };
  const errorElem = document.getElementById('errorScroll');

  if (errorElem && getErrorMsg.length > 0) {
      errorElem.scrollIntoView();
  }
  const errorMessages = [...new Set(getErrorMsg?.map((obj) => obj.message))];

  const onGridReady = (params) => {
    setGridApi(params?.api);
  };

const onFirstDataRendered = (params) => {
    if (mfgListSelected?.length > 0) {
        params.forEachNode(
          (node) =>
            -1 !==
              mfgListSelected?.findIndex((x) => {
                return x?.mfgId == node.data?.mfgId;
              }) && node.setSelected(true)
        );
    }
  };  

  const onGridReady1 = (params) => {
    setGridApi(params?.api);
  };
  
  const onFirstDataRendered1 = (params) => {
    if (fetchDisputeCodeList?.length > 0) {
        params.forEachNode(
          (node) =>
            -1 !==
              fetchDisputeCodeList?.findIndex((x) => {
                return x?.codeValuetemp == node.data?.codeValuetemp;
              }) && node.setSelected(true)
        );
    }
    };    

  return (
    <div
      className="tabs-container tBillPanel custom-check"
      data-testid="dispute-code"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Summary Reports" parent2="Dispute Code" />
      <div id="errorScroll">
        <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      </div>
      {!fullScreenView && (
        <>
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="radio-button-for-rcdd"
                id="radio-button-for-rcdd_id"
                labelName="Plan Type"
                required
                optionList={radioList || []}
                defaultValue={state && state.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4 frr-two-col-radio ">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Rebate Program<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-3">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="rebateProgram"
                      id="rebate_program"
                      label="Rebate Program"
                      fullWidth
                      select
                      required
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      value={
                        state && state.rebateProgramCd
                          ? state.rebateProgramCd
                          : ''
                      }
                      error={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      helperText={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramList?.length > 0
                        ? rebateProgramList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Quarter Range<span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <RadioGroup row name="date-range">
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              label="Begin"
                              id="Begin"
                              placeholder=""
                              required
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={startQtr}
                              onChange={handlefromChange}
                              onBlur={(e) =>
                                handleOnblurEvent('startQtr', e.target.value)
                              }
                              className={
                                getErrorMsg?.length > 0
                                  ? _.map(getErrorMsg, (l) =>
                                      l.field == 'startQtr'
                                        ? 'mandate-fields'
                                        : null
                                    )
                                  : null
                              }
                              helperText={
                                getErrorMsg?.length > 0
                                  ? [
                                      ...new Set(
                                        _.map(getErrorMsg, (l) =>
                                          l.field === 'startQtr'
                                            ? l.message
                                            : null
                                        )
                                      ),
                                    ]
                                  : null
                              }
                              inputProps={{ maxLength: 6 }}
                              name="start"
                              error={
                                getErrorMsg?.length > 0 &&
                                getErrorMsg?.filter((x) => {
                                  return x.field === 'startQtr';
                                }).length > 0
                                  ? [
                                      ...new Set(
                                        getErrorMsg
                                          ?.filter((x) => {
                                            return x.field === 'startQtr';
                                          })
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : false
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              label="End"
                              id="End"
                              placeholder=""
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{ maxLength: 6 }}
                              name="end"
                              value={endQtr}
                              onChange={handleToChange}
                              onBlur={(e) =>
                                handleOnblurEvent(
                                  'endQtr' || 'startQtr>endQtr',
                                  e.target.value
                                )
                              }
                              className={
                                getErrorMsg?.length > 0
                                  ? _.map(getErrorMsg, (l) =>
                                      l.field == 'startQtr>endQtr'
                                        ? 'mandate-fields'
                                        : null
                                    )
                                  : null
                              }
                              helperText={
                                getErrorMsg?.length > 0
                                  ? _.map(getErrorMsg, (l) =>
                                      l.field === 'startQtr>endQtr'
                                        ? l.message
                                        : null
                                    )
                                  : null
                              }
                              error={
                                getErrorMsg?.length > 0 &&
                                getErrorMsg?.filter((x) => {
                                  return (
                                    x.field === 'startQtr' ||
                                    x.field === 'startQtr>endQtr'
                                  );
                                }).length > 0
                                  ? [
                                      ...new Set(
                                        getErrorMsg
                                          ?.filter((x) => {
                                            return (
                                              x.field === 'startQtr>endQtr'
                                            );
                                          })
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : false
                              }
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Basis for Drug Selection
                </legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <FormControl>
                        <RadioGroup
                          row
                          name="Basis for Drug Selection"
                          value={drugSelection}
                        >
                          <FormControlLabel
                            style={{ marginRight: '90px' }}
                            value="Dispute"
                            control={<Radio />}
                            label="A Dispute exists for the Selected Codes"
                            onChange={(e) => setDrugSelection(e.target.value)}
                          />
                          <FormControlLabel
                            value="Adjustment"
                            control={<Radio />}
                            label="An Adjustment exists for the Selected Codes"
                            onChange={(e) => setDrugSelection(e.target.value)}
                          />
                          <FormControlLabel
                            style={{ marginRight: '68px' }}
                            value="Both"
                            control={<Radio />}
                            label="Either exists for the Selected Code"
                            onChange={(e) => setDrugSelection(e.target.value)}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-6  frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Dispute Status</legend>
                <div className="form-wrapper p-4">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <RadioGroup row name="report-quarter" required>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues.open}
                            color="primary"
                            name="open"
                            onChange={(e) => {
                              setCheckboxValues({
                                ...checkboxValues,
                                open: !checkboxValues.open,
                              });
                            }}
                          />
                        }
                        label="open"
                        disabled={drugSelection == 'Adjustment'}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxValues.closed}
                            color="primary"
                            name="closed"
                            onChange={(e) => {
                              setCheckboxValues({
                                ...checkboxValues,
                                closed: !checkboxValues.closed,
                              });
                            }}
                          />
                        }
                        label="closed"
                        disabled={drugSelection == 'Adjustment'}
                      />
                    </RadioGroup>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="row">
            <div className="col-6 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Manufacturer</legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <FormControl>
                        <RadioGroup
                          row
                          name="Manufacturer"
                          required
                          value={selectedValue}
                        >
                          <FormControlLabel
                            // style={{ marginRight: '10px' }}
                            value="-1"
                            control={<Radio />}
                            label="All"
                            data-test="All"
                            onChange={(e) => {
                              setselectedValue(e.target.value);
                              onSelectionChanged({}, e.target.value);
                              let localErr = getErrorMsg || [];
                              localErr = localErr.filter(
                                (item) => item.field != 'nomanufacture'
                              );
                              const unique = [...new Set(localErr)];
                              dispatch(dispatchErrorMsgDisputeCode(unique));
                            }}
                          />
                          <FormControlLabel
                            // style={{ marginRight: '10px' }}
                            value="Selected"
                            control={<Radio />}
                            label="Selected"
                            data-test="Selected"
                            onChange={(e) => setselectedValue(e.target.value)}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-6 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Select Dispute Codes
                </legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <FormControl>
                        <RadioGroup
                          row
                          name="Selected Dispute Codes"
                          required
                          value={selectedDisputeCodes}
                        >
                          <FormControlLabel
                            value="All"
                            control={<Radio />}
                            label="All"
                            onChange={(e) => {
                              setselectedDisputeCodes(e.target.value);
                              onSelectionCodeChanged({}, e.target.value);
                              let localErr = getErrorMsg || [];
                              localErr = localErr.filter(
                                (item) => item.field != 'noCodeSelected'
                              );
                              const unique = [...new Set(localErr)];
                              dispatch(dispatchErrorMsgDisputeCode(unique));
                            }}
                          />
                          <FormControlLabel
                            value="Selected"
                            control={<Radio />}
                            label="Selected"
                            onChange={(e) =>
                              setselectedDisputeCodes(e.target.value)
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div className="col-12 btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="view_detail_ia"
                type="button"
                onClick={onClickOnSearch}
              >
                {' '}
                <SVGComponent iconName="Icon-search" /> {'  '} Search
              </Button>
            </div>
          </div>
        </>
      )}
      <br />
      <br />

      {selectedValue == 'Selected' && (
        <div className="col-12 unallocated">
          <TableGrid
            onSelectionChanged={onSelectionChanged}
            getSelectedRowData={getSelectedRowData}
            selectRowIndex={selectedRowIndexValue}
            gridCall={onGridReady}
            gridDataRendered={onFirstDataRendered}
            ref={gridRef}
            data-testid="manufacturer-grid"
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            columnDefs={ManufactureTableHead}
            rowData={manufacturerList || []}
            rowSelection="multiple"
            rowMultiSelectWithClick
            singleClickEdit
            exportFile
            animateRows
            sideBar={false}
            fileName="Manufacturer Grid"
            suppressRowClickSelection
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            hideColumnsInPdf
            onCellFocused={onCellFocused}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 30) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      )}

      {selectedDisputeCodes == 'Selected' && (
        <div className="col-12 unallocated">
          <TableGrid
            onSelectionChanged={onSelectionCodeChanged}
            getSelectedRowData={getSelectedCodeRowData}
            selectRowIndex={selectedRowIndexCodeValue}
            gridCall={onGridReady1}
            gridDataRendered={onFirstDataRendered1}
            ref={gridRef}
            data-testid="dispute-codes-selected"
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={selectedCode}
            columnDefs={DisputeCodesSelected}
            rowSelection="multiple"
            rowMultiSelectWithClick
            exportFile
            animateRows
            sideBar={false}
            fileName="Dispute Codes Selected"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            hideColumnsInPdf
            onCellFocused={onCellFocused}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 30) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DisputeCodes;
